<template>

    <section class="w-100 d-flex flex-column">

        <!-- Loading -->
        <loading/>

        <!-- Form Create -->
        <div class="order-1 formcreatepagesbase" id="header">

            <h1 class="my-3" aria-describedby="Create Page Section">Create Page</h1>
            
            <form-page
                :inputvalidation="inputValidation"
                :checkpercomma="checkPerComma"
                :disabled="disabled"
                formaction="insert"
                @form-data="sendData($event)"
                :pagetype="pagetype"
            />

        </div>

        <!-- Pages List -->
        <div class="order-2 showpages mt-3">

            <h2 class="my-3" aria-describedby="All Pages List">All Pages</h2>

            <!-- Module Actions -->
            <module-action
                :csrftolken="csrftolken"
                :alldata="pagelist"
                @dynamic-data="getDynamicDataFromModuleAction($event)"
                :orderurl="orderurl"
                :searchurl="searchurl"
                classname=""
            >

                <template #custom_action>
                </template>

            </module-action>

            <!-- Check Page List -->
            <template v-if="Object.values(allpages).length > 0">

                <!-- Page List Render-->
                <table-element :classname="['table-striped']">

                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">User Created</th>
                            <th scope="col">Title</th>
                            <th scope="col">Slug</th>
                            <th scope="col">Keywords</th>
                            <th scope="col">Description</th>
                            <th scope="col">Active</th>
                            <th scope="col">Type</th>
                            <th scope="col">Created</th>
                            <th scope="col">Updated</th>
                            <!-- <th scope="col">SoftDelete</th> -->
                            <th scope="col">Actions</th>
                        </tr>
                    </template>

                    <!-- Tbody -->
                    <template #tbody>

                        <tr v-for="(value, index) in allpages" :key="value.id" :data-referid="index" :data-pageid="value.id" :data-userid="value.user_id">
                            <th scope="row">{{ value.id }}</th>
                            <td>{{ value.user_name }}</td>
                            <td>{{ value.title }}</td>
                            <td>{{ value.slug }}</td>
                            <td>{{ value.keywords }}</td>
                            <td>{{ resumeMessage(value.description, 15, 2) }}</td>
                            <td>
                                <button @click="buttonsAction($event, 'active')" class="btn btn-light" type="button" data-action="1">
                                    {{ value.active }}
                                </button>
                            </td>
                            <td>{{ firstLetterUpperCase(value.type) }}</td>
                            <td>{{ value.created_at }}</td>
                            <td>{{ value.updated_at }}</td>
                            <td>{{ value.deleted_at }}</td>
                            <td class="d-flex flex-row justify-content-between">
                                <button class="btn btn-primary" @click="showModal($event)" data-action="2">Edit</button>
                                
                                <!--
                                <template v-if="!value.deleted_at">
                                    <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'softdelete')" data-action="3">Delete</button>
                                </template>
                                
                                <template v-else>
                                    <button class="btn btn-info" type="button" @click="buttonsAction($event, 'restore')" data-action="4">Restore</button>
                                </template> -->
                                
                                <div v-if="parseInt(value.user_rule) === 1">
                                    <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'remove')" data-action="5">Remove</button>
                                </div>

                            </td>
                        </tr>

                    </template>

                </table-element>

            </template>

            <template v-else>

                <span>Please create Pages</span>

            </template>

            <!-- Pagination active -->
            <pagination 
                :totalpages="parseInt(totalpages)"
                :firstpageurl="firstpage"
                :otherpagesurl="adminPageUrl"
                modulename="pages"
            />

        </div>

        <!-- Back To Top -->
        <back-to-top 
            idhref="header"
        />

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>
        
        <!-- Modal for Form Update -->
        <modal
            title="Edit Pages"
            classname="formpagesupdate"
        >

            <template #modalcontent>

                <form-page
                    :inputvalidation="inputValidation"
                    :checkpercomma="checkPerComma"
                    :disablededit="disablededit"
                    formaction="update"
                    @form-data="sendData($event)"
                    :edittitle="computedEditTitle"
                    :editkeywords="computedEditKeywords"
                    :editdescription="computedEditDescription"
                    :edittypeofpage="computedPageTypeEdit"
                    :pageidedit="pageidedit"
                    :pagelist="pageList"
                    :pagereferid="computedPageReferId"
                    :pagetype="pagetype"
                    :disabledbutton="disabledButtonEdit"
                />

            </template>

        </modal>    

    </section>

</template>

<script>

    import fetchData from './../../fetchData.js';
    import Table from './../elements/TableElement.vue';
    import ListMessage from './../elements/ListMessageElement.vue';
    import FormPage from './../elements/FormPageElement.vue';
    import Loading from './../elements/LoadingElement.vue';
    import Modal from './../elements/ModalElement.vue';
    import store from '../../store/index.js';
    import validation from './../../inputValidation.js';
    import Pagination from './../elements/PaginationElement.vue';
    import BackToTop from './../elements/BackToTopElement.vue';
    import ModuleAction from './../elements/ModuleActionElement.vue';

    //Set Use Strict
    "use strict";

    export default{
        name: 'Pages',
        props:{
            csrftolken:{
                type: String,
                required: true
            },
            pagelist:{
                type: String,
                required: true
            },
            pagecreate:{
                type: String,
                required: true
            },
            pageupdate:{
                type: String,
                required: true
            },
            pagesoftdelete:{
                type: String,
                required: true
            },
            pagerestoresoftdelete:{
                type: String,
                required: true
            },
            pagedelete:{
                type: String,
                required: true
            },
            pageactive:{
                type: String,
                required: true
            },
            adminurl:{
                type: String,
                required: true
            },
            firstpage:{
                type: String,
                required: true
            },
            totalpages:{
                type: String,   
                required: true
            },
            orderurl:{
                type: String,
                required: true
            },
            searchurl:{
                type: String,
                required: true
            }

        },
        data: () => {

            return{

                allpages: {},
                disabled: true,
                disablededit: false,
                activeclass: 'd-flex',
                edittitle: '',
                editkeywords: '',
                editdescription: '',
                edittypeofpage: '',
                pageidedit: 0,
                buttonsaction: {
                    formaction: '',
                    id: ''
                },
                pagereferid: '',
                pagetype: [
                    {
                        id: 1,
                        type: "Home"
                    },
                    {
                        id: 2,
                        type: "Page"
                    },
                    {
                        id: 3,
                        type: "Blog"
                    },
                    {
                        id: 4,
                        type: "Contact"
                    },
                    {
                        id: 5,
                        type: "Workwithus"
                    },
                    {
                        id: 6,
                        type: "UnderConstruction"
                    },
                    {
                        id: 7,
                        type: "Preview"
                    },
                    {
                        id: 8,
                        type: "Reserve"
                    },
                    {
                        id: 9,
                        type: "Login"
                    },
                    {
                        id: 10,
                        type: "Professional"
                    },
                    {
                        id: 11,
                        type: "Result"
                    },
                    {
                        id: 12,
                        type: "Plp"
                    },
                    {
                        id: 13,
                        type: "Checkout"
                    },
                    {
                        id: 14,
                        type: "Test"
                    },
                ],
                adminPageUrl: '',
                getCurrentPage: ''
            }

        },
        created(){

            //Set Default Value for Pages URL checkout
            this.adminPageUrl = this.adminurl + '/admin/website/pages/page=';

            //Set Current Page Value
            this.getCurrentPage = window.location.pathname.includes('page=') ? parseInt(window.location.pathname.replace('/admin/pages/page=', '')) : 1;

        },
        beforeMount() {

            //Set Page List
            if(this.pagelist.length > 0){

                Object.assign(this.allpages, JSON.parse(this.pagelist));

                //Set Store Pages List
                store.state.pageslist = JSON.parse(this.pagelist);

            }
          

        },
        mounted() {

            //console.log(store.state.pageslist);

        },
        methods:{

            getDynamicDataFromModuleAction(dynamicData){

                //Set Dynamic Data when clean search input
                if(dynamicData !== undefined && 
                typeof dynamicData === 'object' &&
                Object.values(dynamicData).length > 0){

                    //Get Default Module Data
                    this.allpages = dynamicData;

                }

            },
            disabledButtonEdit(){

                if(this.formaction === 'update'){

                    this.disablededit = false;

                }

            },
            resumeMessage(text, limit, divisor){

                //console.log(text);
                if(text !== undefined){

                    let resume = text.length > limit ?
                    `${text.substr(0, Math.round(text.length / divisor))}...` : text;

                    return resume;

                }

            },
            showModal(element){

                //Show Modal
                $(".formpagesupdate").modal("show");

                //Get Index from Page List
                this.pagereferid = element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

                //Get Values from Page List
                let currentPage = Object.values(this.allpages).find((value, index) => index === parseInt(this.pagereferid));

                //console.log(currentPage.type);

                //Set Dynamic values for update
                this.edittitle = currentPage.title;
                this.editkeywords = currentPage.keywords;
                this.editdescription = currentPage.description;
                this.edittypeofpage = currentPage.type;
                this.pageidedit = parseInt(currentPage.id);

                return;

            },
            hideModal(){

                //Hide Modal
                $(".formpagesupdate").modal("hide");

            },
            checkPerComma(element, inputid){

                //Check if exist commas
                let commaExist = element.currentTarget.value.includes(',');

                //Check Value
                if(element.currentTarget.value !== '' && !commaExist){

                    //Input Validation Class
                    let validate = new validation(1, element, inputid);

                    //Conditional for generate an error message
                    validate.createErrorMessageElement(inputid, 'Please separete words with comma');

                    //Disable Submit
                    return this.disabled = true;

                }

                return;

            },
            inputValidation(element, inputid){

                //Check Value
                if(element.currentTarget.value !== ''){
                
                    //Input Validation Class
                    let validate = new validation(1, element, inputid);

                    //Check by inputid
                    switch(inputid)
                    {

                        //Title
                        case 'page_title':
                        case 'page_titleedit':    
                            //Check Validation
                            this.disabled = validate.onlyLettersAndSpacesAndNumbers(element, inputid, 6);
                            this.disablededit = validate.onlyLettersAndSpacesAndNumbers(element, inputid, 6);
                        break;

                        //keywords
                        case 'page_keywords':
                        case 'page_keywordsedit':       
                            //Check Validation
                            this.disabled = validate.onlyLettersAndSpacesAndNumbers(element, inputid, 3);
                            this.disablededit = validate.onlyLettersAndSpacesAndNumbers(element, inputid, 3);
                        break;

                        //description
                        case 'page_description':
                        case 'page_descriptionedit':        
                            //Check Validation
                            this.disabled = validate.onlyLettersAndSpacesAndNumbers(element, inputid, 4);
                            this.disablededit = validate.onlyLettersAndSpacesAndNumbers(element, inputid, 4);
                        break;

                    }

                }

            },
            dataStructureResponse(responseObject){

                //Get Key and Value
                let entries = Object.entries(responseObject);

                //Loop response conditional
                for(const [key, value] of entries){

                    switch(key)
                    {

                        case 'attListData':

                            //Set New Att Datalist
                            this.allpages = value;
                            //store.state.pageslist = value;
                            
                            //Clean Variable
                            this.buttonsaction.id = '';
                            this.buttonsaction.formaction = '';
                            this.disablededit = false;

                            //Check Property
                            if(this.buttonsaction.hasOwnProperty('activeaction')){

                                //Remove property
                                delete this.buttonsaction.activeaction;

                            }

                        break;

                        case 'successMessage':
                        case 'errorMessage':
                            
                            //Add active Class
                            this.$refs.responsebasemessage.classList.add(this.activeclass);
                            this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                            //Set Messages List
                            value.forEach((valmessage) => {

                                //Element for append
                                let li = `<li class="list-group item my-1">${valmessage}</li>`;

                                //Append Element
                                $(li).appendTo(this.$refs.responsebasemessage.children);

                            });
                            

                        break;

                    }

                }

                //Remove Base Response Message
                this.removeResponseMessages();

                return this.allpages;

            },
            removeResponseMessages(time = 5000){

                setTimeout(function(){

                    //Remove active class
                    document.querySelector('.responsebasemessage').classList.remove('d-flex');
                    document.querySelector('.responsebasemessage').classList.remove('successmessage');
                    document.querySelector('.responsebasemessage').classList.remove('errormessage');

                    //Remove children elements
                    let ul = document.querySelector('.responsebasemessage').children;

                    [...ul[0].children].forEach((valli) => {

                        //Remove Elements
                        valli.remove();

                    });

                }, time);

            },
            firstLetterUpperCase(submitMessage){

                //Caps First Letter
                let firstletter = submitMessage.at(0).toUpperCase();
                let fieldname = submitMessage.replace(submitMessage.at(0), firstletter);

                return fieldname;

            },
            checkDataConditionalSubmit(checkval, valdata, submitMessage){

                //Check data conditional
                if(!checkval || valdata === ''){
                    
                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Caps First Letter
                    let fieldname = this.firstLetterUpperCase(submitMessage);

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(this.activeclass);

                    //Element for append
                    let li = `<li class="list-group item my-1">Please inform valid data for the ${fieldname}</li>`;

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Base Response Message
                    this.removeResponseMessages();

                    //Remove Span Error Message
                    document.querySelector('span.errorMessage').remove();

                    return;

                }

                return;

            },
            buttonsAction(element, action){

                //Get Index from Page List
                let parentReferId = action === 'remove' ? 
                element.currentTarget.parentElement.parentElement.parentElement.getAttribute('data-referid') : 
                element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

                //Get Values from Page List
                let currentPage = Object.values(this.allpages).find((value, index) => index === parseInt(parentReferId));

                //Set Formaction
                switch(action)
                {

                    case 'softdelete':
                        this.buttonsaction.formaction = 'softdelete';
                    break;

                    case 'restore':
                        this.buttonsaction.formaction = 'restoresoftdelete';
                    break;

                    case 'remove':
                    case 'active':

                        //Confirm
                        let confirmAction = confirm(`Are you sure do you want to ${action} this page?`);

                        //Confirm Remove Action
                        if(confirmAction){

                            this.buttonsaction.formaction = action === 'remove' ? 'delete' : 'active';

                        }else{

                            return;

                        }
                       
                    break;

                }

                //Set Page Id
                this.buttonsaction.id = currentPage.id;

                //Set Active Action
                if(action === 'active'){

                    this.buttonsaction.activeaction = element.currentTarget.textContent.trim();

                }

                //Send Data for delete
                return this.sendData(this.buttonsaction);

            },
            sendData(formdata){

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Disabled Submit
                this.disabled = true;

                //Check formaction for check error value conditional
                if(formdata.formaction !== 'softdelete' ||
                   formdata.formaction !== 'restoresoftdelete' ||
                   formdata.formaction !== 'delete'
                ){

                    //Check Data before send
                    for(let [keydata, valdata] of Object.entries(formdata)){

                        let element = '';
                        let inputid = '';

                        //Input Validation Class
                        let validate = new validation(1, element, inputid);

                        //Set type of the validation regex
                        let checkval;

                        switch(keydata)
                        {

                            case 'title':
                                checkval = 9;
                            break;

                            case 'keywords':
                                checkval = 3;
                            break;

                            case 'description':
                                checkval = 4;
                            break;

                            case 'type':
                                checkval = 1;
                            break;

                        }

                        //Check data Conditional
                        if(!validate.validNameCases(checkval, valdata)){

                            return this.checkDataConditionalSubmit(validate.validNameCases(checkval, valdata), valdata, keydata);

                        }

                    }

                }

                //Set Current Page
                formdata.currentpage = this.getCurrentPage;

                //Set Route
                let method;
                let urlmethod; 

                switch(formdata.formaction)
                {

                    case 'insert':

                        method = 'POST';
                        urlmethod = this.pagecreate;

                    break;

                    case 'update':

                        method = 'PUT';
                        urlmethod = this.pageupdate;

                    break;

                    case 'softdelete':

                        method = 'PUT';
                        urlmethod = this.pagesoftdelete;

                    break;

                    case 'restoresoftdelete':

                        method = 'PUT';
                        urlmethod = this.pagerestoresoftdelete;

                    break;

                    case 'delete':

                        method = 'DELETE';
                        urlmethod = this.pagedelete;

                    break;

                    case 'active':

                        method = 'PUT';
                        urlmethod = this.pageactive;

                    break;


                }

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, formdata, this.csrftolken, method);
                
                //Check Response
                response.then((value) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Check Form Action
                    if(formdata.formaction === 'update'){

                        //Hide Modal
                        this.hideModal();

                    }

                    //Generate a Response
                    return this.dataStructureResponse(value);

                }).catch((error) => {

                    //Show Error Message
                    alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;

                    throw new Error(error);

                })

            }

        },
        computed:{

            pageList(){

                return Array.isArray(this.allpages) ? this.allpages : Object.values(this.allpages);

            },
            computedEditTitle(){

                return this.edittitle;

            },
            computedEditKeywords(){

                return this.editkeywords;

            },
            computedEditDescription(){

                return this.editdescription;

            },
            computedPageReferId(){

                return this.pagereferid;

            },
            computedPageTypeEdit(){

                return this.edittypeofpage;

            },
            computedDisabledEdit(){

                return this.disablededit;

            }

        },
        watch:{

            pageList(){},
            computedEditTitle(){},
            computedEditKeywords(){},
            computedEditDescription(){},
            computedPageReferId(){},
            computedPageTypeEdit(){},
            computedDisabledEdit(){}

        },
        components:{

            tableElement:Table,
            listMessage: ListMessage,
            formPage: FormPage,
            loading: Loading,
            modal: Modal,
            pagination: Pagination,
            backToTop: BackToTop,
            moduleAction: ModuleAction

        }

    }

</script>